// extracted by mini-css-extract-plugin
module.exports = {"bottomDownloadSectionBackground":"BottomDownloadSection_bottomDownloadSectionBackground__by_bh"};